import { fromPromise } from 'xstate5';

import { initialContext, type ScanToPayContext } from './scan-to-pay.machine.context';
import { type PaymentMethod, type PointsReward } from './scan-to-pay.machine.types';

// ─── Actors ──────────────────────────────────────────────────────────────────

const fetchData = fromPromise<FetchDataResponse>(async () => ({
  availablePoints: initialContext.availablePoints,
  availableCredit: initialContext.availableCredit,
  paymentMethods: initialContext.paymentMethods,
  pointsRewards: initialContext.pointsRewards,
}));

const fetchIdentifyToken = fromPromise<FetchIdentifyTokenResponse>(async () => ({
  identifyToken: '',
}));

const fetchPaymentToken = fromPromise<FetchPaymentTokenResponse, ScanToPayContext>(async () => ({
  paymentToken: '',
}));

const fetchCredits = fromPromise<FetchCreditsResponse>(async () => ({
  availableCredit: 0,
}));

export const ScanToPayActors = {
  fetchData,
  fetchIdentifyToken,
  fetchPaymentToken,
  fetchCredits,
};

// ─── Types ───────────────────────────────────────────────────────────────────

export type FetchDataResponse = {
  availableCredit: number;
  availablePoints: number;
  paymentMethods: readonly PaymentMethod[];
  pointsRewards: readonly PointsReward[];
};

export type FetchIdentifyTokenResponse = {
  identifyToken: string;
};

export type FetchPaymentTokenResponse = {
  paymentToken: string;
};

export type FetchCreditsResponse = {
  availableCredit: number;
};

export type ScanToPayMachineServices = Readonly<{
  fetchData: {
    data: FetchDataResponse;
  };
  fetchIdentifyToken: {
    data: FetchIdentifyTokenResponse;
  };
  fetchPaymentToken: {
    data: FetchPaymentTokenResponse;
  };
  fetchCredits: {
    data: FetchCreditsResponse;
  };
}>;
